<template>
  <section class="intro_section">

    <the-header
      :introDiscoveryTextProp="'Discover More'"
      :introDiscoveryLinkProp='"/discovery"'
      :musicFromHomeProp='musicFromHomeProp'
    >
    </the-header>

    <section class="wrapper discover__section intro">
      <div class="text__center discover__section__text">
        <p
          @mouseover="MX_isZoom(true)"
          @mouseleave="MX_isZoom(false)"
        >
          BurgundysCollection offers a new way to allocate exclusive Burgundies to discerning wine lovers,
          <br>
          that truly protects and respects the wine, the maker and the drinker.
        </p>
      </div>
    </section>

    <next-page :nextPageProp="'/discovery'" :activeClassProp="true"></next-page>
  </section>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import NextPage from '@/components/VNextPage.vue'
import { isZooming } from '../mixins/isZooming'
import { mapGetters } from 'vuex'

export default {
  name: 'IntroDiscover',
  components: {
    'the-header': TheHeader,
    'next-page': NextPage
  },
  mixins: [
    isZooming
  ],
  computed: {
    isMusicOn: {
      get () {
        return this.$store.state.audio.isMusicOn
      },
      set (payload) {
        this.$store.commit('updateAudioStatus', payload)
      }
    },
    ...mapGetters([
      'generateAudioPath',
      // 'generateHoverAudioPath',
      'generateOpenAudioPath'
      // 'generateCrossAudioPath'
    ])
  },
  mounted () {
    this.$store.commit('updateCursorType', 1)
    // this.$root.$emit('playMusic', true)
    this.endFirstTrack()
  },
  props: {
    musicFromHomeProp: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    endFirstTrack () {
      if (this.isMusicOn) {
        let checkEndedFirstTrack = setInterval(() => {
          if (this.generateOpenAudioPath.volume === 0) {
            this.generateOpenAudioPath.currentTime = 0
            this.generateOpenAudioPath.pause()
            clearInterval(checkEndedFirstTrack)
            this.startSecondTrack()
          }
          if (this.generateOpenAudioPath.volume === 1) {
            let currentVolume1 = this.generateOpenAudioPath.volume
            let volumeDown = setInterval(() => {
              if (this.generateOpenAudioPath.volume === 0) {
                this.generateOpenAudioPath.currentTime = 0
                this.generateOpenAudioPath.pause()
                clearInterval(volumeDown)
                this.startSecondTrack()
              }
              currentVolume1 -= 0.025
              this.generateOpenAudioPath.volume = currentVolume1 > 0 ? currentVolume1 : 0
            }, 100)
          }
        }, 100)
      }
    },
    startSecondTrack () {
      if (this.generateAudioPath.currentTime === 0) {
        this.generateAudioPath.volume = 0
        this.generateAudioPath.play()
        let currentVolume = 0
        let volumeUp = setInterval(() => {
          currentVolume += 0.025
          this.generateAudioPath.volume = currentVolume < 1 ? currentVolume : 1
          if (this.generateAudioPath.volume === 1) {
            clearInterval(volumeUp)
          }
        }, 100)
      }
    }
  }
}
</script>
